import axios from "axios";
import { globalState } from "./globalState";
import { clearPendingOtpSession } from "./otpSession";

const AUTH_SESSION_PATH = "/api/auth-session";

function authSessionConfig() {
  return { withCredentials: true, baseURL: "" };
}

/**
 * Todas las llamadas van al BFF en `/api/backend` (Azure Functions en SWA;
 * en local, `vue.config.js` proxy → `func start` en `api/`).
 * El JWT de suscriptor viaja en cookie HttpOnly; el BFF arma Authorization hacia el API.
 */
export function applyAxiosAuthHeaders() {
  axios.defaults.baseURL = "/api/backend";
  axios.defaults.withCredentials = true;
  delete axios.defaults.headers.common.SUBSCRIPTION_API_KEY;
  delete axios.defaults.headers.common.Authorization;
}

async function persistSubscriberSessionCookie(jwt) {
  await axios.post(
    AUTH_SESSION_PATH,
    { token: String(jwt).trim() },
    authSessionConfig()
  );
}

async function clearSubscriberSessionCookie() {
  await axios.delete(AUTH_SESSION_PATH, authSessionConfig());
}

/**
 * Sincroniza cookie HttpOnly si hay JWT en localStorage (p. ej. tras recargar la página).
 */
export async function syncSubscriberSessionCookie() {
  const jwt = localStorage.getItem("subscriberToken");
  if (!jwt || !String(jwt).trim()) {
    return;
  }
  try {
    await persistSubscriberSessionCookie(jwt);
  } catch (err) {
    console.warn("[auth] sync auth-session cookie:", err?.message || err);
  }
}

/** Guarda el JWT de suscriptor, cookie HttpOnly y configuración de axios. */
export async function setSubscriberToken(jwt) {
  if (jwt && String(jwt).trim()) {
    localStorage.setItem("subscriberToken", String(jwt).trim());
  } else {
    localStorage.removeItem("subscriberToken");
  }
  applyAxiosAuthHeaders();
  if (jwt && String(jwt).trim()) {
    try {
      await persistSubscriberSessionCookie(jwt);
    } catch (err) {
      console.warn("[auth] auth-session cookie:", err?.message || err);
    }
  }
}

/** Cierra sesión del flujo de suscripción (voluntario). */
export async function logoutSubscriptionUser() {
  localStorage.removeItem("authenticatedUser");
  localStorage.removeItem("cartProducts");
  localStorage.removeItem("currentStep");
  localStorage.removeItem("profileReturnStep");
  localStorage.removeItem("token");
  await clearSubscriberToken();
}

/** Quita sesión de suscriptor (localStorage, cookie). */
export async function clearSubscriberToken() {
  localStorage.removeItem("subscriberToken");
  clearPendingOtpSession();
  applyAxiosAuthHeaders();
  try {
    await clearSubscriberSessionCookie();
  } catch (err) {
    console.warn("[auth] clear auth-session:", err?.message || err);
  }
}

/**
 * Limpia datos de sesión del flujo (misma idea que `deleteSession` en CheckUser)
 * y marca `globalState.sessionInvalidated` para que App.vue sincronice el estado.
 */
export async function invalidateSubscriptionSession() {
  clearPendingOtpSession();
  await logoutSubscriptionUser();
  globalState.sessionInvalidated = true;
}
